export const formatTime = (sec) => {
  const m = String(Math.floor(sec / 60)).padStart(2, "0");
  const s = String(sec % 60).padStart(2, "0");
  return `${m}:${s}`;
};

export const estimateTimeLeft = (elapsedTime) => {
  if (!elapsedTime) return "calculating...";
  return `~${Math.ceil(elapsedTime * 1.3)} sec`;
};

export const getInterleavedColumns = (photos, colCount) => {
  const cols = Array.from({ length: colCount }, () => []);
  photos.forEach((photo, globalIndex) => {
    const colIndex = globalIndex % colCount;
    cols[colIndex].push({ photo, globalIndex });
  });
  return cols;
};
